import { reactive, computed } from '@vue/composition-api'
import store from '@/store'

/**
 * QA詳細画面：目次エリアツリー表示
 */
export const getGroup = (props, context) => {

  const group1 = reactive({

    /**
     * 初期表示処理
     */
    init: () => {
    },
    // ハイライト表示フラグ（現在選択されているQAの場合にハイライト表示）
    isSelected: computed(() => {
      return (props.model.id !== 0 && props.model.id === store.state.qa.qaId)
    }),
    isOpen: computed(() => {
      return (props.model.id === 0 || props.model.isOpen)
    }),
    isFolder: computed(() => {
      return (typeof props.model.children !== 'undefined') && 
              (Array.isArray(props.model.children)) &&
              (props.model.children.length > 0) 
    }),
    children: computed(() => {
      return props.model.children
    }),
    /**
     * フォルダのオープン/クローズの切り替え
     */
    toggle: () => {
      props.model.isOpen = !props.model.isOpen
    },

    /**
     * 目次のQAタイトルがクリックされた場合
     * @param {numeric} qaID QA ID
     */
    onQATitleClicked: (qaId) => {
      
      // ルートにイベントの実行を伝える
      // （最終的に、QADetail.jsで、本文を切り替える処理を行う）
      group1.emitTitleClicked(qaId)
    },

    /**
     * ルートのノードにイベントの実行を伝える
     */
    emitTitleClicked: (qaId) => {
      context.emit('emitTitleClicked', qaId)
    }

  })

  return group1
}
